import { Backdrop, CircularProgress } from '@mui/material';
import { useSelector } from 'react-redux';

function LoadingSpinner() {
  const loading = useSelector(state => state.auth.loading);

  return (
    <Backdrop
      sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
      open={loading}
    >
      <CircularProgress color="inherit" />
    </Backdrop>
  );
}

export default LoadingSpinner; 